import { push } from "src/features/Notification/notificationSlice";
import { useSelector, useDispatch } from "react-redux";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import React, { useEffect } from "react";

import { fetchList, approve, deny } from "./ducks";
import Card from "./Card";

function Index() {
  const dispatch = useDispatch();
  // const fetching = useSelector((state) => state.newMember.fetching)
  const total = useSelector((state) => state.newMember.total);
  const list = useSelector((state) => state.newMember.list);

  useEffect(() => {
    dispatch(fetchList());
  }, [dispatch]);

  const onApprove = (_id, store_name) => async () => {
    let d = window.confirm(
      'Are you sure you want to approve this "' + store_name + '" store'
    );
    if (d) {
      try {
        await dispatch(approve(_id));
        dispatch(fetchList());
      } catch (error) {
        console.log(error);
        dispatch(
          push({
            title: "Error",
            description: "An error occurred, Please try again later.",
            severity: "error",
          })
        );
      }
    }
  };

  const onDeny = (_id, store_name) => async () => {
    let d = window.confirm(
      'Are you sure you want to deny this "' + store_name + '" store'
    );
    if (d) {
      try {
        await dispatch(deny(_id));
        dispatch(fetchList());
      } catch (error) {
        dispatch(
          push({
            title: "Error",
            description: "An error occurred, Please try again later.",
            severity: "error",
          })
        );
      }
    }
  };

  return (
    <div>
      <Box mt={3} mb={2}>
        You have new {total} member(s) to registration
      </Box>

      <Grid container spacing={2}>
        {list.map((item) => (
          <Grid key={item._id} item xs={6} lg={4}>
            <Card {...item} onApprove={onApprove} onDeny={onDeny} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default Index;
